import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import Loader from '../../../components/Loader';
import { Text } from '../../../components/Text';
import { Menu } from 'primereact/menu';
import { Button } from 'primereact/button';

import { CustomButton } from '../../../components/CustomButton';
import { AddNewProduct } from '../../../components/Forms/AddNewProduct';
import { ReactComponent as Edit } from '../../../svg/edit.svg';
import { ReactComponent as Delete } from '../../../svg/delete.svg';
import { DeleteAlert } from '../../../components/Alert/DeleteAlert';
import GroupShare from '../../../components/GroupShare';
import CustomPaginator from '../../../components/CustomPaginator';
import { ReactComponent as Approve } from '../../../svg/approve.svg';
import { ReactComponent as DisApprove } from '../../../svg/disapprove.svg';
import { ReactComponent as Pending } from '../../../svg/inprogress.svg';
import {
  changeSelectedProduct,
  changeMode,
  changePage,
  updateSelectedProductsList,
  resetAll,
  changelimit,
  changeSelectedProductBlist,
  // bulkDeleteProduct,
} from '../../../reducers/wca/product/product-slice';
import { getProducts } from '../../../reducers/wca/product/product-action';
import { useDispatch, useSelector } from 'react-redux';
import Notice from '../../../components/Alert/Notice';
import { Dropdown } from 'primereact/dropdown';
import { changeShowGroupShareDialog, changeSuccessfullCampaign } from '../../../reducers/appSlice';
import { Image } from 'primereact/image';
import TableActionsContainer from '../../../components/CustomTable/TableActionsContainer';
import DebounceSearch from '../../../components/common/DebounceSearch';
import EllipsisText from '../../../components/common/EllipsisText/indix';
import { useNavigate } from 'react-router';
import { changeTemplateType } from '../../../reducers/templateReducer/templateSlice';
import { resetBroadcast } from '../../../reducers/ShareMessage/messageSlice';
import { updatecustomers } from '../../../reducers/customerTableSlice';
import ImportProductCSV from './ImportProductCSV';
import modulesName from '../../../roles/modulesName';
import permissions from '../../../roles/permissions';
import { useUtility } from '../../../context/UtilityContext';
const ProductListWCA = () => {
  const { productData, loading, page, limit, totalProductCount, selectedProductsList, cursor } =
    useSelector((state) => state.productTableWCA);

  const [displayAddProductModule, setDisplayAddProductModule] = useState(false);
  const [displayAlertDelete, setDisplayAlertDelete] = useState(false);
  const [bulkDeleteAlert, setBulkDeleteAlert] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const { showNotice, showGroupShareDialog } = useSelector((state) => state.application);
  const { successfullCampaign } = useSelector((state) => state.application);
  const { user } = useSelector((state) => state.authenticate);

  const dispatch = useDispatch();
  const toast = useRef(null);
  const navigate = useNavigate();
  const { selectedMetadataId } = useUtility();
  ///filter--------------------------------
  const [filtersData, setFiltersData] = useState({
    availability: '',
  });

  const [filters1, setFilters1] = useState({
    availability: { value: '' },
  });

  useEffect(() => {
    if (successfullCampaign) {
      let Message_Success = 'Campaign successfully added';
      toast.current.show({ severity: 'success', detail: Message_Success });
    }
    dispatch(changeSuccessfullCampaign(false));
  }, [successfullCampaign]);

  let stocks = ['in stock', 'out of stock'];

  const stockFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={stocks}
        onChange={(e) => {
          options.filterCallback(e.value, options.index);
        }}
        itemTemplate={stockItemTemplate}
        placeholder="Select Stock"
        className="p-column-filter"
      />
    );
  };

  const stockItemTemplate = (option) => {
    return <span className={`customer-badge status-${option}`}>{option}</span>;
  };

  const onClearStatusFilter = () => {
    setFilters1((prev) => {
      return {
        ...prev,
        status: {
          ...prev.status,
          value: '',
        },
      };
    });

    setFiltersData((prev) => {
      return {
        ...prev,
        status: '',
      };
    });
  };

  const onClickFilter = (e) => {
    switch (e.field) {
      case 'status':
        setFilters1((prev) => {
          return {
            ...prev,
            status: {
              ...prev.status,
              value: e.constraints.value,
            },
          };
        });

        setFiltersData((prev) => {
          return {
            ...prev,
            status: e.constraints.value,
          };
        });
        break;
      default:
        break;
    }
  };

  //--------------------------------------------

  const handleEdit = (product) => {
    dispatch(changeMode('update'));
    dispatch(changeSelectedProduct(product));
    navigate(`/products/${product.id}/update`);
  };
  const handleDelete = (product) => {
    dispatch(changeMode('delete'));
    dispatch(changeSelectedProduct(product));
    setDisplayAlertDelete(true);
  };
  const { userSub, accesskey } = useSelector((state) => state.authenticate);

  const handleShare = () => {
    if (!userSub.isUserSub) {
      toast.current.show({
        severity: 'error',
        detail: 'For broadcast inquiries, contact our agent.',
      });
      return;
    }
    if (selectedProductsList.length > 30) {
      toast.current.show({
        severity: 'error',
        detail: 'Only Less Than 30 Products Can be Share',
      });
      return;
    }
    const temp = selectedProductsList;
    dispatch(resetAll());
    dispatch(resetBroadcast());
    dispatch(changeTemplateType('product'));
    dispatch(updatecustomers({ selectedCust: [] }));
    dispatch(changeSelectedProductBlist([...temp]));
    navigate(`/runcampaign/new`);
  };

  const addProductModal = () => {
    return (
      <AddNewProduct
        displayAddProductModule={displayAddProductModule}
        setDisplayAddProductModule={setDisplayAddProductModule}
        toast={toast}
      />
    );
  };

  const modalLoad = () => {
    return (
      <div>
        <Loader visible={loading} />
      </div>
    );
  };

  const deleteModule = () => {
    return (
      <DeleteAlert
        item="product"
        displayAlertDelete={displayAlertDelete}
        setDisplayAlertDelete={setDisplayAlertDelete}
        toast={toast}
      />
    );
  };

  const actionBodyTemplate = (rowData) => {
    const checkProductSelected = (prod) => {
      for (let i = 0; i < selectedProductsList.length; i++) {
        if (selectedProductsList[i].id === prod.id) return true;
      }

      return false;
    };
    return (
      <div className="flex justify-content-start align-items-center">
        {accesskey[modulesName.PRODUCT]?.includes(permissions.UPDATE) && (
          <CustomButton
            varient="icon-button"
            icon={<Edit />}
            onClick={() => handleEdit(rowData)}
            disabled={checkProductSelected(rowData)}
            style={{ padding: '0px' }}
          />
        )}
        {accesskey[modulesName.PRODUCT]?.includes(permissions.DELETE) && (
          <CustomButton
            varient="icon-button"
            icon={<Delete />}
            onClick={() => handleDelete(rowData)}
            disabled={checkProductSelected(rowData)}
            style={{ padding: '0px' }}
          />
        )}
      </div>
    );
  };

  function onSelectProduct(e) {
    const selectedProducts = e.value;
    const currProducts = productData;
    dispatch(updateSelectedProductsList({ selectedProducts, currProducts }));
  }

  const isSelectable = (data) => {
    const { availability } = data;
    return availability === 'in stock';
  };

  const isRowSelectable = (e) => {
    return isSelectable(e.data);
  };

  const rowClassName = (data) => {
    return isSelectable(data) ? '' : 'not-selectable';
  };

  // const handleBulkDelete = () => {
  //   const prodIds = selectedProductsList?.map((prod) => prod.id);
  //   dispatch(bulkDeleteProduct(prodIds))
  //     .unwrap()
  //     .then((res) => {
  //       setBulkDeleteAlert(false);
  //       toast.current.show({
  //         severity: 'success',
  //         detail: `${res.length} Products deleted successfully`,
  //         life: 3000,
  //       });
  //     })
  //     .catch((err) => {
  //       toast.current.show({
  //         severity: 'error',
  //         detail: err?.message,
  //         life: 3000,
  //       });
  //     });
  // };

  useEffect(() => {
    dispatch(getProducts({ metadataId: selectedMetadataId, cursor: null, search: inputValue }))
      .unwrap()
      .catch(() => {
        //show toast from here
      });
  }, [selectedMetadataId, inputValue, filtersData]);

  const handleNext = () => {
    if (!cursor?.after) return;

    dispatch(
      getProducts({
        metadataId: selectedMetadataId,
        cursor: cursor.after,
        limit,
        search: inputValue,
      }),
    );
  };

  const handlePrevious = () => {
    if (!cursor?.before) return;

    dispatch(
      getProducts({
        metadataId: selectedMetadataId,
        cursor: cursor.before,
        limit,
        search: inputValue,
      }),
    );
  };

  return (
    <div className="p-3">
      {/* {bulkDeleteAlert && (
        <SklbtConfirmation
          visible={bulkDeleteAlert}
          handleConfirm={handleBulkDelete}
          handleReject={() => setBulkDeleteAlert(false)}
          message={`Are you sure, you want to delete ${selectedProductsList.length} products?`}
        />
      )} */}
      <Toast ref={toast} />
      <TableActionsContainer>
        <div className="flex justify-content-between align-items-center flex-wrap gap-3">
          <div className="flex gap-2 align-items-center">
            <Text type={'heading'}>Product List111</Text>
            {/* {selectedProductsList.length != 0 && (
              <CustomButton
                label={
                  <Text>({selectedProductsList.length}) Delete Selected </Text>
                }
                varient="icon-button"
                onClick={() => setBulkDeleteAlert(true)}
              />
            )} */}
          </div>
          <div className="flex gap-3 flex-wrap-reverse">
            <DebounceSearch
              placeholder={'Search Product'}
              inputValue={inputValue}
              handleInputChange={(value) => setInputValue(value)}
            />
            <div className="flex gap-2 ">
              {accesskey[modulesName.PRODUCT]?.includes(permissions.CREATE) && <ImportProductCSV />}
              {accesskey[modulesName.PRODUCT]?.includes(permissions.CREATE) && (
                <CustomButton
                  varient="filled"
                  label={'Add Product'}
                  icon={'pi pi-plus'}
                  onClick={() => navigate('/products/new')}
                />
              )}
              {accesskey[modulesName.CAMPAIGN]?.includes(permissions.CREATE) && (
                <CustomButton
                  varient="filled"
                  label={'Share Selected'}
                  onClick={() => handleShare('all')}
                  icon={'pi pi-external-link'}
                  disabled={!selectedProductsList.length}
                />
              )}
            </div>
          </div>
        </div>
      </TableActionsContainer>
      <div className="card my-3">
        {displayAddProductModule && addProductModal()}
        {showGroupShareDialog && <GroupShare label={'Share selected product'} />}
        {modalLoad()}
        {displayAlertDelete && deleteModule()}
        <div className="p-fluid">
          {/* {showNotice && (
            <Notice message={"Products will be uploaded every midnight."} />
          )} */}
          <DataTable
            value={productData}
            selection={selectedProductsList}
            onSelectionChange={onSelectProduct}
            dataKey="id"
            className="skalebot-table"
            selectionMode={
              accesskey[modulesName.CAMPAIGN]?.includes(permissions.CREATE) ? 'checkbox' : ''
            }
            filters={filters1}
            filterDisplay="menu"
            globalFilterFields={['availability']}
            isDataSelectable={isRowSelectable}
            rowClassName={rowClassName}
          >
            {accesskey[modulesName.CAMPAIGN]?.includes(permissions.CREATE) && (
              <Column
                selectionMode="multiple"
                headerStyle={{ width: '3rem' }}
                exportable={false}
              ></Column>
            )}
            <Column
              field="id"
              header="SKUId"
              style={{ maxWidth: '25ch' }}
              className="uppercase text-sm font-normal"
            ></Column>
            <Column
              field="name"
              header="Name"
              className="text-sm font-normal"
              style={{ maxWidth: '300px' }}
              body={(rowData) => (
                <EllipsisText className={'white-space-nowrap'} text={rowData.name} />
              )}
            ></Column>
            <Column
              field="category"
              header="Category"
              className="text-sm font-normal"
              style={{ maxWidth: '300px' }}
              body={(rowData) => (
                <EllipsisText className={'white-space-nowrap'} text={rowData.category} />
              )}
            ></Column>

            <Column
              field="availability"
              header={() => {
                return (
                  <div className="flex gap-2 align-items-end">
                    <Text>Stock</Text>
                  </div>
                );
              }}
              showFilterMatchModes={false}
              filter
              style={{ maxWidth: '8rem' }}
              filterElement={stockFilterTemplate}
              onFilterApplyClick={(e) => onClickFilter(e)}
              onFilterClear={onClearStatusFilter}
            ></Column>
            <Column field="price" header={<Text>Price&nbsp;(₹) </Text>}></Column>
            <Column
              header="Image"
              body={(rowData) => (
                <Image src={rowData?.image_url} width="48px" height="48px" preview />
              )}
              bodyStyle={{ display: 'flex' }}
            ></Column>
            <Column
              field="description"
              header="Description"
              style={{ minWidth: '250px', maxWidth: '350px' }}
              body={(rowData) => <EllipsisText text={rowData.description} />}
            ></Column>
            {(accesskey[modulesName.PRODUCT]?.includes(permissions.CREATE) ||
              accesskey[modulesName.PRODUCT]?.includes(permissions.DELETE)) && (
              <Column
                header="Actions"
                body={actionBodyTemplate}
                exportable={false}
                style={{ maxWidth: '100px' }}
              ></Column>
            )}
          </DataTable>
        </div>
        <div className="mt-3">
          <TableActionsContainer>
            <div className="flex justify-content-between align-items-center mt-3">
              <div className="flex gap-2">
                <Button
                  label="Previous"
                  icon="pi pi-arrow-left"
                  onClick={handlePrevious}
                  disabled={!cursor?.before || loading}
                  outlined
                />

                <Button
                  label="Next"
                  icon="pi pi-arrow-right"
                  iconPos="right"
                  onClick={handleNext}
                  disabled={!cursor?.after || loading}
                />
              </div>
            </div>
          </TableActionsContainer>
        </div>
      </div>
    </div>
  );
};

export default ProductListWCA;
